import { render, staticRenderFns } from "./FavoritePerson.vue?vue&type=template&id=164e5f43"
import script from "./FavoritePerson.vue?vue&type=script&lang=js"
export * from "./FavoritePerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports